const ENUM = {
    KEY : {
        CHANGED : "_changed",
        CATS : "categories",
        USER_CATEGORIES : "user-categories"
    },
    VIEWS : {
        APP : "app",
        IN : "in",
        DEFAULT : "welcome",
        LOGIN : "log-in",
        LOGOUT : "sign-out",
        REGISTER : "sign-up",
        CONTACT_US : "contact-us",
        TERMS : "terms-of-service",

        //APP MODULES:
        OVERSEER : "overseer",
        OVERVIEW : "overview",
        SETTING : "account",

        //IN MODULES:
        CONTACT : "contact",
        DASHBOARD : "dashboard",
        MY_ACCOUNT : "my-account",
        BUDGET : "budget",
        TOOL : "tools",
        TRACKER : "tracker",
        REPORTS : "reports",

        isValid : function(value){
            for(let propName in ENUM.VIEWS){
                let propVal = this[propName];
                if(propVal === value){
                    return true;
                }
            }
            return false;
        },

        getModuleName : function(l1Path){
            let name = ENUM.VIEWS.DEFAULT; // default page when path is not found
            if(ENUM.VIEWS.isValid(l1Path))
                name = l1Path;
            //use this switch to override any value. eg, to set the same module for different paths.
            switch(l1Path){
                //case ENUM.VIEWS.SIGNUP : name = ENUM.VIEWS.SIGN_IN_UP; break;
            }
            return name;
        },

        isInModule(l1Name){
            let yesItIs = false;
            switch(l1Name){
                case ENUM.VIEWS.CONTACT:
                case ENUM.VIEWS.DASHBOARD:
                case ENUM.VIEWS.MY_ACCOUNT:
                case ENUM.VIEWS.BUDGET:
                case ENUM.VIEWS.TOOL:
                case ENUM.VIEWS.REPORTS:
                    yesItIs = true; break;
            }
            return yesItIs;
        }
    }
};

module.exports = ENUM;


// WEBPACK FOOTER //
// ./src/control/core/Enum.js